// extracted by mini-css-extract-plugin
export default {"settingsFormWrapper":"settingsFormElement_settingsFormWrapper__Xnjnw","settingForm":"settingsFormElement_settingForm__M6zMi"};